import { render, staticRenderFns } from "./FormControlTypeSelectOther.vue?vue&type=template&id=9facd3e0&scoped=true"
import script from "./FormControlTypeSelectOther.vue?vue&type=script&lang=js"
export * from "./FormControlTypeSelectOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9facd3e0",
  null
  
)

export default component.exports